import { z } from 'zod'

export const travelAmountStatisticsMonthDetailSchema = z.object({
  /** 月份 */
  month: z.string(),
  /** 金額 */
  amount: z.number()
})

export interface TravelAmountStatisticsMonthDetail
  extends z.infer<typeof travelAmountStatisticsMonthDetailSchema> {}
